import { ref, computed, onMounted, onBeforeUnmount, watch, getCurrentInstance } from 'vue';
import { useRoute } from 'vue-router';
import mitt from 'mitt';
import { formatHostForUrl } from '@/js/util';
export function useIndex(){

const route = useRoute();
const bus = mitt();

const instance = getCurrentInstance();
const $api = instance?.appContext.config.globalProperties.$api;
const $sakura = instance?.appContext.config.globalProperties.$sakura;


const loopTimer = ref(null);
const loopObj = ref({
  name: '',
  path: '',
  number: 0,
  time: 0,
  disable: true,
});

const queryList = computed(() => [
  { name: 'overview', path: '/configure/overview', number: 0, time: 30, disable: false },
  { name: 'networks', path: '/configure/virtualNetworks', number: 0, time: 60, disable: false },
]);

const checkLoop = (path) => {
  const one = queryList.value.find(item => item.path === path);
  loopObj.value = one ? JSON.parse(JSON.stringify(one)) : { ...loopObj.value };
};

const initEmit = () => {
  bus.on('loop', ({ name, disable }) => {
    const one = queryList.value.find(item => item.name === name);
    if (one) {
      loopObj.value.disable = disable;
      if (!disable) {
        loopObj.value = JSON.parse(JSON.stringify(one));
      }
    }
  });
};

const initLoopHandler = () => {
  loopTimer.value = setInterval(() => {
    let { disable, number, time, name } = loopObj.value;
    if (!disable) {
      if (number < time) {
        number++;
        loopObj.value.number = number;
      } else {
        loopObj.value.number = 0;
        sendLoopHandler(name);
      }
    }
  }, 1000);
};

const sendLoopHandler = (name) => {
  if (name) bus.emit(`loop:${name}`);
};

const oldHandler = () => {
  $api.common.queryHttpPort()
      .then(json => {
        if (json.resp.respCode === 0) {
          const { http, https } = json.ipHttpConfig;
          if(!http.mode && !https.mode){
                        return $sakura.showMessage("Cannot use Main UI when both HTTP and HTTPS are disabled.");
          }
          const protocolScheme = https.mode ? 'https' : 'http';
          const protocol = https.mode ? https : http;
          window.open(`${protocolScheme}://${formatHostForUrl(location.hostname)}:${protocol.port}/v1/base/cheetah_login.html`);
        } else {
          $sakura.showMessage(json.resp.respCode);
        }
      })
      .catch(error => {
        console.error("Error in oldHandler:", error);
      });
};

watch(() => route.path, (newPath) => {
  checkLoop(newPath);
}, { immediate: true });

onMounted(() => {
  checkLoop(route.path);
  initEmit();
  initLoopHandler();
});

onBeforeUnmount(() => {
  clearInterval(loopTimer.value);
});

  return {
    loopTimer,
    loopObj,
    queryList,
    checkLoop,
    initEmit,
    initLoopHandler,
    sendLoopHandler,
    oldHandler,
  }
}
